// ===========================================================================
// ProCare.SG — content hooks
// ---------------------------------------------------------------------------
// Thin wrappers over the API service so pages get a consistent
// { data, loading, error } shape and never update state after unmounting.
// ===========================================================================
import { useEffect, useState } from "react";
import { getBlogPosts, getProjects, getTestimonials } from "@/services/api";

function useCollection(loader, fallback = []) {
    const [state, setState] = useState({ data: fallback, loading: true, error: null });

    useEffect(() => {
        let active = true;
        setState((current) => ({ ...current, loading: true }));
        loader()
            .then((data) => active && setState({ data, loading: false, error: null }))
            .catch((error) => {
                if (!active) return;
                console.error("[content] load failed", error);
                setState({ data: fallback, loading: false, error });
            });
        return () => {
            active = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return state;
}

export const useProjects = () => useCollection(getProjects);
export const usePosts = () => useCollection(getBlogPosts);
export const useTestimonials = () => useCollection(getTestimonials);

/** ["All", …categories present in the data] — never shows an empty filter. */
export function useCategories(items, key = "category") {
    const found = [...new Set((items || []).map((item) => item[key]).filter(Boolean))].sort();
    return ["All", ...found];
}
